/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface TextValueListDto
 */
export interface TextValueListDto {
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TextValueListDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextValueListDto
     */
    availableValues?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TextValueListDto
     */
    selectedValues?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TextValueListDto
     */
    $type?: TextValueListDtoTypeEnum;
}


/**
 * @export
 */
export const TextValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersTextValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TextValueListDtoTypeEnum = typeof TextValueListDtoTypeEnum[keyof typeof TextValueListDtoTypeEnum];


/**
 * Check if a given object implements the TextValueListDto interface.
 */
export function instanceOfTextValueListDto(value?: unknown): value is TextValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextValueListDtoTypeEnum)[0];
}

export function TextValueListDtoFromJSON(json: any): TextValueListDto {
    return TextValueListDtoFromJSONTyped(json, false);
}

export function TextValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextValueListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': !exists(json, 'dataTypeId') ? undefined : json['dataTypeId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'availableValues': !exists(json, 'availableValues') ? undefined : json['availableValues'],
        'selectedValues': !exists(json, 'selectedValues') ? undefined : json['selectedValues'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TextValueListDtoToJSON(value?: TextValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'dataTypeId': value.dataTypeId,
        'name': value.name,
        'iuid': value.iuid,
        'origin': EntityOriginToJSON(value.origin),
        'availableValues': value.availableValues,
        'selectedValues': value.selectedValues,
        'isEnabled': value.isEnabled,
        '$type': value.$type,
    });
}

